const DEFAULT_BASE_URL = ''

export const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL || DEFAULT_BASE_URL).replace(/\/$/, '')

let accessToken = null


export function setAccessToken(token) {
  accessToken = token
}

export function getAccessToken() {
  return accessToken
}

export function clearAccessToken() {
  accessToken = null
}

export class ApiError extends Error {
  constructor(message, { status, body } = {}) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.body = body
  }
}

async function readBodySafe(response) {
  const contentType = response.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    try {
      return await response.json()
    } catch {
      return null
    }
  }

  try {
    return await response.text()
  } catch {
    return null
  }
}

export async function apiFetch(path, { method = 'GET', body, headers, skipAuth, ...init } = {}) {
  const url = `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`
  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData
  const hasBody = body !== undefined && body !== null

  const authHeaders = {}
  if (!skipAuth && accessToken) {
    authHeaders['Authorization'] = `Bearer ${accessToken}`
  }

  let res = await fetch(url, {
    method,
    credentials: 'include',
    headers: {
      ...authHeaders,
      ...(!isFormData && hasBody ? { 'Content-Type': 'application/json' } : null),
      ...headers,
    },
    body: hasBody ? (isFormData ? body : JSON.stringify(body)) : undefined,
    ...init,
  })

  if (res.status === 401 && !skipAuth && !path.startsWith('/auth/')) {
    const refreshed = await tryRefreshToken()
    if (refreshed) {
      res = await fetch(url, {
        method,
        credentials: 'include',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          ...(!isFormData && hasBody ? { 'Content-Type': 'application/json' } : null),
          ...headers,
        },
        body: hasBody ? (isFormData ? body : JSON.stringify(body)) : undefined,
        ...init,
      })
    }
  }

  if (!res.ok) {
    const responseBody = await readBodySafe(res)
    throw new ApiError(`Request failed: ${method} ${path}`, {
      status: res.status,
      body: responseBody,
    })
  }

  const responseBody = await readBodySafe(res)
  return responseBody
}

async function tryRefreshToken() {
  try {
    const refreshUrl = `${API_BASE_URL}/auth/refresh`
    const res = await fetch(refreshUrl, {
      method: 'POST',
      credentials: 'include',
    })
    if (!res.ok) return false

    const data = await res.json()
    if (data?.access_token) {
      accessToken = data.access_token
      return true
    }
    return false
  } catch {
    return false
  }
}

export function getHealth() {
  return apiFetch('/health')
}
